"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_intl_1 = require("react-intl");
var useForceUpdate_1 = require("../../../../common/hooks/useForceUpdate");
var useCustomErrorMessagesMapper = function (formData) {
    var intl = react_intl_1.useIntl();
    var forceUpdate = useForceUpdate_1.default().forceUpdate;
    var getErrorDomain = function (errorPath) {
        var pathArray = errorPath.split('.');
        return pathArray[pathArray.length - 1];
    };
    var isFieldDirty = function (domain, formData) {
        if (!formData || typeof formData !== 'object') {
            return false;
        }
        if (domain in formData) {
            return !!formData[domain];
        }
        return Object.values(formData).some(function (value) {
            return isFieldDirty(domain, value);
        });
    };
    var filterDirtyFields = function (errors, formData) {
        if (!formData)
            return errors;
        return errors.filter(function (error) {
            var domain = getErrorDomain(error.property);
            return isFieldDirty(domain, formData);
        });
    };
    react_1.useEffect(function () {
        forceUpdate();
    }, [formData]);
    return react_1.useCallback(function (errors) { var _a; return (_a = filterDirtyFields(errors, formData)) === null || _a === void 0 ? void 0 : _a.map(function (error) {
        if (error.name === 'maximum') {
            error.message = intl.formatMessage({ id: 'trans__se__error_messages__in_store_error_message' });
        }
        return error;
    }); }, [formData, intl]);
};
exports.default = useCustomErrorMessagesMapper;
